<router-outlet>
    
        <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="medium" color="#fff" type="timer" zIndex="99999" >
            
            <br>
            <br>
            <p style="font-size:20px; color: white;">Cargando...</p>
        </ngx-spinner>
    
</router-outlet>